@if (showSelectionModal) { @if (!isSuccess) {
<div>
  @if (generateType==='DRAFT') {
  <app-dialog-title>
    {{ labelGenerateDraft ? "Generate" : "Preview" }} Draft Package
  </app-dialog-title>
  } @if (generateType==='STANDARD') {
  <app-dialog-title>
    {{
      config.tenant === tenants.FR
        ? "Generate Final Documents"
        : "Generate Standard Package"
    }}
  </app-dialog-title>
  }
  <form>
    @if (templates.templateFlagTrue.length > 0 ||
    templates.templateFlagFalse.length > 0) {
    <mat-dialog-content class="content scrolling">
      @if (generateType==='DRAFT') {
      <p>
        Select template(s) to
        {{ labelGenerateDraft ? "generate" : "preview" }} draft file(s)
      </p>
      } @if (generateType==='STANDARD') {
      <p>
        {{
          config.tenant === tenants.FR
            ? "Select template(s) to generate final document(s)"
            : "Select template(s) to generate standard file(s)"
        }}
      </p>
      }
      <table class="ui striped table" width="100%" cellspacing="0">
        <thead>
          <tr class="view-modal-title">
            <th>{{ "template" | transloco }}</th>
            <th *transloco="let t">
              {{ labelGenerateDraft ? t("generate") : t("preview") }}
            </th>
            <th>{{ "type" | transloco }}</th>
          </tr>
        </thead>
        <tbody>
          @for (t of templates.templateFlagTrue; track t) {
          <tr class="selectable">
            <td>{{ t.form }}</td>
            <td>
              <input
                type="checkbox"
                (click)="updateFlag(t, $event.target.checked)"
                [checked]="t.flag"
              />
            </td>
            <td>
              {{ templateTypesMap.get(t.form)?.alias | templateType: formType }}
            </td>
          </tr>
          }
        </tbody>
        @if (showMore) {
        <tbody class="fade-in">
          @for (t of templates.templateFlagFalse; track t) {
          <tr class="selectable">
            <td>{{ t.form }}</td>
            <td>
              <input
                type="checkbox"
                (click)="updateFlag(t, $event.target.checked)"
                [checked]="t.flag"
              />
            </td>
            <td>
              {{ templateTypesMap.get(t.form)?.alias | templateType: formType }}
            </td>
          </tr>
          }
        </tbody>
        }
      </table>
      @if (!showMore) {
      <a class="generate-draft__toggle-button" (click)="showMore = true">{{
        "show-more" | transloco
      }}</a>
      }
    </mat-dialog-content>
    } @if (templates.templateFlagTrue.length === 0 &&
    templates.templateFlagFalse.length === 0) {
    <div>
      <p class="no-available-form">
        {{ "no-available-template-to-select" | transloco }}
      </p>
    </div>
    }
  </form>
  <mat-dialog-actions align="end">
    @if (isAdmin) {
    <span class="left"
      ><input type="checkbox" (click)="updateDebug($event.target.checked)" />
      Debug</span
    >
    }
    <span class="go-back cancel" (click)="onClose()">{{
      "cancel" | transloco
    }}</span>
    <button
      (click)="confirmSelection()"
      class="ui primary button"
      [ngClass]="{
        disabled: generateButtonFlag || isGenerating,
        loading: isGenerating
      }"
    >
      {{ "generate" | transloco }}
    </button>
  </mat-dialog-actions>
</div>
} @if (isSuccess) {
<div>
  @if (generateType==='DRAFT') {
  <app-dialog-title>
    Draft Package {{ labelGenerateDraft ? "Generated" : "Preview Generated" }}
  </app-dialog-title>
  } @if (generateType==='STANDARD') {
  <app-dialog-title>
    {{
      config.tenant === tenants.FR
        ? "Final Tax Documents Generation Completed"
        : "Standard Package Generated"
    }}
  </app-dialog-title>
  } @if (generateDraftResult) {
  <mat-dialog-content class="content">
    @for (message of generateDraftResult.messages; track message) {
    <div>
      {{ message }}
    </div>
    }
    <ul>
      @for (f of generateDraftResult.forms; track f) {
      <li class="draft-item">
        {{ f.name }}
        @if (f.success) {
        <i class="check icon draft-item__success"></i>
        } @if (f.botDumpSuccess === true) {
        <span
          ><i class="check icon draft-item__success"></i
          >{{ "sent-to-bot" | transloco }}</span
        >
        } @if (f.botDumpSuccess === false) {
        <span
          ><i class="check icon draft-item__fail"></i
          >{{ "could-not-send-to-bot" | transloco }}</span
        >
        } @if (!f.success) {
        <i class="close icon draft-item__fail"></i>
        }
        <div class="error-message">
          {{ f.message }}
        </div>
      </li>
      }
    </ul>
  </mat-dialog-content>
  } @if (isAdmin && generateDraftResult.debug) {
  <span>
    Excel & PDF:
    <textarea>{{ debugOther }}</textarea>
    Word:
    <textarea>{{ debugDocx }}</textarea>
  </span>
  }
  <mat-dialog-actions align="end">
    <button
      (click)="onClose(true)"
      class="ui primary background button approve"
    >
      {{ "ok" | transloco }}
    </button>
  </mat-dialog-actions>
</div>
} }
